import { ComponentProps, forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { Textarea } from '../default/textarea';

export const CustomTextarea = forwardRef<HTMLTextAreaElement, ComponentProps<typeof Textarea>>(
  ({ className, ...props }, ref) => {
    return (
      <Textarea
        className={cn(
          'border-shade-light-default px-4 py-2 placeholder:text-[14px] placeholder:text-[#B7C9C9] md:text-base',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
